import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.css']
})
export class ScannerComponent implements OnInit {

  information = 'Place a QR code in front of the camera to scan';
  device: MediaDeviceInfo | null = null;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  public scanSuccessHandler(url: any): void {
    if (url.indexOf('https://thetwisted.co.uk/') > -1) {
      this.information = 'Loading';
      this.router.navigate([url.replace('https://thetwisted.co.uk/', '')]).then(() => {
        window.location.reload();
      });

    } else {
      this.information = 'QR Code not valid. please try again';

    }


  }

  camerasFound(event): void {
    this.device = event[0];
  }


}
